export default [
  {
    path: "/account-Management/users",
    name: "Users-index",
    component: () => import("@/views/acount-management/portal/users/index.vue"),
    meta: {
      resource: "Account",
      action: "View",
    },
  },
  {
    path: "/account-Management/client-users",
    name: "ClientAccount-GetAll",
    component: () => import("@/views/acount-management/client/users/index.vue"),
    meta: {
      resource: "ClientAccount",
      action: "GetAll",
    },
  },
  {
    path: "/account-Management/create-user",
    name: "accountManagement-create-user",
    component: () => import("@/views/acount-management/portal/users/Add.vue"),
    meta: {
      resource: "Account",
      action: "Save",
    },
  },
  {
    path: "/account-Management/create-client-user",
    name: "ClientAccount-Add",
    component: () => import("@/views/acount-management/client/users/Add.vue"),
    meta: {
      resource: "ClientAccount",
      action: "Add",
    },
  },
  {
    path: "/account-Management/edit-user/:id",
    name: "accountManagement-edit-user",
    component: () => import("@/views/acount-management/portal/users/Edit.vue"),
    meta: {
      resource: "Account",
      action: "Update",
    },
  },
  {
    path: "/account-Management/roles",
    name: "Roles-index",
    component: () => import("@/views/acount-management/portal/roles/index.vue"),
    meta: {
      resource: "Role",
      action: "View",
    },
  },
  {
    path: "/account-Management/client-roles",
    name: "ClientRole-GetAll",
    component: () => import("@/views/acount-management/client/roles/index.vue"),
    meta: {
      resource: "ClientRole",
      action: "GetAll",
    },
  },
  {
    path: "/account-Management/create-role",
    name: "accountManagement-create-role",
    component: () => import("@/views/acount-management/portal/roles/Add.vue"),
    meta: {
      resource: "Role",
      action: "Save",
    },
  },
  {
    path: "/account-Management/create-client-role",
    name: "ClientRole-Add",
    component: () => import("@/views/acount-management/client/roles/Add.vue"),
    meta: {
      resource: "ClientRole",
      action: "Save",
    },
  },
  {
    path: "/account-Management/edit-role/:id",
    name: "accountManagement-edit-role",
    component: () => import("@/views/acount-management/portal/roles/Edit.vue"),
    meta: {
      resource: "Role",
      action: "Update",
    },
  },
  {
    path: "/account-Management/edit-client-role/:id",
    name: "ClientRole-Update",
    component: () => import("@/views/acount-management/client/roles/Edit.vue"),
    meta: {
      resource: "ClientRole",
      action: "Update",
    },
  },
  {
    path: "/account-Management/change-password",
    name: "accountManagement-change-password",
    component: () =>
      import("@/views/acount-management/portal/users/changePassword.vue"),
    meta: {
      resource: "Password",
      action: "Change",
    },
  },
  {
    path: "/account-Management/privilage",
    name: "Privilage-View",
    component: () => import("@/views/acount-management/portal/privilage/index.vue"),
    meta: {
      resource: "Previlage",
      action: "View",
    },
  },
  {
    path: "/account-Management/client-privilage",
    name: "ClientPrivileges-GetAll",
    component: () => import("@/views/acount-management/client/privilage/index.vue"),
    meta: {
      resource: "ClientPrivileges",
      action: "GetAll",
    },
  },
];
